@if (!state.isOpen) {
  <button type="button" class="support-chat-bubble-pill" (click)="openBubble()">
    <i class="ph-bold ph-sparkle"></i>
    <span>{{ pillLabel }}</span>
    @if (state.hasUnread) {
      <dk-unread-icon class="support-chat-bubble-unread" aria-hidden="true"></dk-unread-icon>
    }
  </button>
} @else {
  <div class="support-chat-bubble-card">
    <button
      type="button"
      class="support-chat-bubble-minimize"
      [attr.aria-label]="'doktar_app.common.close' | translate"
      (click)="closeBubble()">
      <i class="ph ph-minus"></i>
    </button>

    <div class="support-chat-bubble-body">
      <dk-support-ticket-chat
        surface="bubble"
        [inquiryId]="state.activeInquiryId"
        [forcePanelType]="SupportTicketChatState.Welcome"
        (chatCreated)="onChatCreated($event)"></dk-support-ticket-chat>
    </div>
  </div>
}
